// AUTO-GENERATED by generate-rxdb-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { defaultHooks } from '../defaults'

const name = 'templates'

/**
 * Template Model Interface (auto-generated from Drizzle schema)
 */
export interface TemplateModel {
  id: string
  orgId: string
  workspaceId: string
  userId?: string
  createdAt: string
  updatedAt: string
  metadata?: Record<string, unknown>
  extended?: Record<string, unknown>
  templateType: string
  name: string
  content: string
  version: string
  isDefault: boolean
  data?: Record<string, unknown>
  tenantId?: string
}

export const schema = {
  title: name,
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
      "id": {
          "type": "string",
          "maxLength": 100
      },
      "orgId": {
          "type": "string",
          "maxLength": 100
      },
      "workspaceId": {
          "type": "string",
          "maxLength": 100
      },
      "userId": {
          "type": "string",
          "maxLength": 100
      },
      "createdAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "updatedAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "metadata": {
          "type": "object"
      },
      "extended": {
          "type": "object"
      },
      "templateType": {
          "type": "string",
          "maxLength": 200
      },
      "name": {
          "type": "string",
          "maxLength": 500
      },
      "content": {
          "type": "string",
          "maxLength": 100000
      },
      "version": {
          "type": "string",
          "maxLength": 200
      },
      "isDefault": {
          "type": "boolean"
      },
      "data": {
          "type": "object"
      },
      "tenantId": {
          "type": "string",
          "maxLength": 100
      }
  },
  required: [
      "id",
      "orgId",
      "createdAt",
      "updatedAt",
      "templateType",
      "name",
      "content",
      "version",
      "isDefault",
      "workspaceId"
  ],
  indexes: [
      [
          "orgId",
          "createdAt"
      ],
      [
          "orgId",
          "workspaceId",
          "createdAt"
      ],
      [
          "workspaceId",
          "createdAt"
      ],
      [
          "templateType",
          "createdAt"
      ],
      [
          "isDefault",
          "createdAt"
      ]
  ],
}

export const migrationStrategies = {}

export const Collection = {
  name,
  schema,
  hooks: {
    ...defaultHooks({ name }),
  },
  migrationStrategies,
}
